"use client"
import { ComponentConfig } from "@measured/puck"
import { EmailSubscriptionProps, RenderConfig } from "./RenderConfig"

export const EmailSubscription: ComponentConfig<EmailSubscriptionProps> = {
  label: "Email Subscription",
  fields: {
    buttonText: {
      type: "text",
      label: "Button Text",
    },
    className: {
      type: "text",
      label: "Class Name",
    },
  },
  defaultProps: {
    buttonText: "",
    className: "",
  },
  ...RenderConfig,
}
